<sc-flex [fitHeight]="true" [stretchContent]="true">
    <div class="info-column">
        <sc-flex [vertical]="true" [stretchContent]="true">
            <div class="icon-container">
                <sc-icon iconClass="fa-check-circle success-icon"></sc-icon>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-read-only-field [label]="'' | translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.numberPlate',
            translationService.language]" [value]="numberPlate"></sc-read-only-field>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-read-only-field [label]="'' | translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.driver',
            translationService.language]" [value]="driver"></sc-read-only-field>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-read-only-field [label]="'' | translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.carrier',
            translationService.language]" [value]="carrier"></sc-read-only-field>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-read-only-field [label]="'' | translate:
            ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.referenceNumber',
            translationService.language]" [value]="orderReference"></sc-read-only-field>
        </sc-flex>
    </div>
    <sc-content-spacer [double]="true"></sc-content-spacer>
    <sc-flex-fitting-content>

        <!--sc-title>{{'Ihre Anmeldung ist abgeschlossen' | translate:
        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
        translationService.language]}}</sc-title-->

        <ng-container *ngIf="gatekeeperMandatory">
            <div class="gatekeeper-hint">
                <sc-padding>
                    {{'gatekeeperMandatory' | translate:
                    ['tmc-yard.widgets.registration-terminal.transport-registration-summary.hint',
                    translationService.language]}}
                </sc-padding>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>

        <ng-container *ngIf="isUsingSmartphone">
            <div class="smartphone-hint">
                <sc-padding>
                    {{'' | translate:
                    ['tmc-yard.widgets.registration-terminal.transport-registration-summary.description',
                    translationService.language]}}
                </sc-padding>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>

        <ng-container *ngFor="let hint of hintDrivers">
            <div class="driver-hint">
                <sc-padding>
                    <sc-dictionary-label [dictionaryKey]="hint"></sc-dictionary-label>
                </sc-padding>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </ng-container>

    </sc-flex-fitting-content>
</sc-flex>